export default class NavigateToUrl {
  constructor(context) {
    this.context = context;
  }

  run(url) {
    this.context.router.navigateToUrl(url);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/current_location/navigate_to_url.js